var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionsStakingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91129 10.3989C2.02692 10.0737 2.38432 9.90383 2.70955 10.0194L9.37204 12.3883C9.77837 12.5328 10.222 12.5328 10.6283 12.3883L17.2908 10.0194C17.616 9.90383 17.9735 10.0737 18.089 10.3989C18.2047 10.7242 18.0348 11.0816 17.7095 11.1972L11.047 13.5661C10.3699 13.8068 9.63046 13.8068 8.95329 13.5661L2.29079 11.1972C1.96555 11.0816 1.79565 10.7242 1.91129 10.3989Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91129 13.9405C2.02692 13.6154 2.38432 13.4455 2.70955 13.561L9.37204 15.93C9.77837 16.0745 10.222 16.0745 10.6283 15.93L17.2908 13.561C17.616 13.4455 17.9735 13.6154 18.089 13.9405C18.2047 14.2658 18.0348 14.6232 17.7095 14.7389L11.047 17.1077C10.3699 17.3485 9.63046 17.3485 8.95329 17.1077L2.29079 14.7389C1.96555 14.6232 1.79565 14.2658 1.91129 13.9405Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9245 4.12656C10.3267 3.90914 9.67138 3.90914 9.07346 4.12656L3.19963 6.2625C3.01678 6.32899 3.01679 6.58759 3.19963 6.65408L9.07346 8.79004C9.67138 9.00745 10.3267 9.00745 10.9245 8.79004L16.7984 6.65408C16.9813 6.58759 16.9813 6.32899 16.7984 6.2625L10.9245 4.12656ZM8.64629 2.95182C9.52013 2.63406 10.478 2.63406 11.3518 2.95182L17.2256 5.08776C18.5055 5.55319 18.5055 7.36339 17.2256 7.82882L11.3518 9.96479C10.478 10.2825 9.52013 10.2825 8.64629 9.96479L2.77246 7.82882C1.49251 7.36339 1.49252 5.55319 2.77246 5.08776L8.64629 2.95182Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsStakingIcon);
export default __webpack_public_path__ + "static/media/subscriptions-staking-icon.eec9b58a08ba597c9baab2fd3be47494.svg";
export { ForwardRef as ReactComponent };